import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Certificates from "./components/Certificates";
import Projects from "./components/Projects";
import Blog from "./components/Blog";
import BlogPost from "./components/BlogPost";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import SEO from "./components/SEO";
import { translations } from "./translations";
import "./App.css";

function App() {
  const [theme, setTheme] = useState("light");
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    // Load theme from localStorage
    const savedTheme = localStorage.getItem("theme") || "light";
    setTheme(savedTheme);
    document.documentElement.setAttribute("data-theme", savedTheme);

    // Load language from localStorage
    const savedLanguage = localStorage.getItem("language") || "en";
    setLanguage(savedLanguage);
    document.documentElement.setAttribute("lang", savedLanguage);
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
  };

  const toggleLanguage = () => {
    const newLanguage = language === "en" ? "fa" : "en";
    setLanguage(newLanguage);
    localStorage.setItem("language", newLanguage);
    document.documentElement.setAttribute("lang", newLanguage);
  };

  const t = translations[language];
  const [currentView, setCurrentView] = useState("home");

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash.startsWith("#blog/")) {
        setCurrentView("blogPost");
      } else if (hash === "#blog") {
        setCurrentView("blog");
      } else {
        setCurrentView("home");
        if (hash === "" || hash === "#home") {
          setTimeout(() => window.scrollTo(0, 0), 100);
        }
      }
    };

    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const handleNavigate = (view) => {
    setCurrentView(view);
    if (view === "home") {
      // Don't clear hash here, let scrollToSection handle it
    }
  };

  const renderContent = () => {
    if (currentView === "blogPost") {
      const slug = window.location.hash.replace("#blog/", "");
      return <BlogPost t={t} language={language} slug={slug} />;
    }
    if (currentView === "blog") {
      return <Blog t={t} language={language} />;
    }
    return (
      <>
        <Hero t={t} language={language} />
        <About t={t} />
        <Skills t={t} />
        <section id="projects" className="section projects-section">
          <h2 className="section-title">
            {language === "fa" ? "پروژه‌ها" : "Projects"}
          </h2>
          <p className="section-subtitle">
            {language === "fa"
              ? "به زودی نمونه‌ای از پروژه‌های فرانت‌اند، هوش مصنوعی و اتوماسیون را که روی آن‌ها کار می‌کنم، اینجا قرار می‌دهم."
              : "Soon I will showcase a selection of my frontend, AI and automation projects that I am actively working on."}
          </p>
        </section>
        <Certificates t={t} />
        {/* <Projects t={t} /> */}
        <Blog t={t} language={language} />
        <Contact t={t} />
      </>
    );
  };

  const seoTitle =
    language === "fa"
      ? "علیرضا ادیبی | توسعه‌دهنده هوش مصنوعی و دانشجوی علوم کامپیوتر"
      : "Alireza Adibi | AI Developer & Computer Science Student";

  const seoDescription =
    language === "fa"
      ? "علیرضا ادیبی | دانشجوی علوم کامپیوتر و توسعه‌دهنده هوش مصنوعی. پورتفولیو شامل پروژه‌ها، مهارت‌ها، گواهینامه‌ها و بلاگ درباره AI و توسعه نرم‌افزار."
      : "Alireza Adibi | Computer Science student and AI developer. Portfolio with projects, skills, certificates and a blog about AI and software development.";

  return (
    <div className="App">
      <SEO language={language} title={seoTitle} description={seoDescription} />
      <Header
        theme={theme}
        toggleTheme={toggleTheme}
        language={language}
        toggleLanguage={toggleLanguage}
        t={t}
        onNavigate={handleNavigate}
      />
      {renderContent()}
      <Footer t={t} />
    </div>
  );
}

export default App;
